import moment from 'moment';

export default function shortDateFormat(value: Date): string {
  if (!value) {
    return '';
  }
  moment.locale('ja');
  return moment(value).format('MM/DD');
}
